import Api from '../../Api';

export default class ReportQuery {

    static CHANGED_EVENT = 'CalculatorChangedEvent';
    static nonce = 0;
    
    constructor(options = {}) {

        this.options = Object.assign(this.getDefaultOptions(), options);
    }

    getDefaultOptions() {

        return {
            tab: null,
            countryId: null,
            calculatorId: null,
            calculatorType: null,
            sum: null,
            initFee: null,
            term: null,
            rate: null,
            creditType: null,
            creditSum: null,
            earlyPayments: [],
        };
    }

    setOption(name, value) {

        this.options[name] = value;
        return this;
    }

    addEarlyPayment(query) {

        query.nonce = ++ReportQuery.nonce;

        this.options.earlyPayments.push(query);
        return this;
    }

    removeEarlyPayment(props) {

        const index = this.options.earlyPayments.findIndex((item) => {

            let founded = true;
            Object
                .keys(props)
                .forEach((key) => {

                    if (props[key] != item[key])
                        founded = false;
                })

            return founded;
        });

        if (index > -1)
            this.options.earlyPayments.splice(index, 1);

        return this;
    }

    fetch(cache = false) {

        if (cache && this.lastFetch != undefined)
            return this.lastFetch;
        
        this.lastFetch = new Promise((resolve) => {

            Api
                .fetch(`${Api.origin}/api/calc/report.json`, {
                    'tab': this.options.tab,
                    'countryId': this.options.countryId,
                    'calculatorId': this.options.calculatorId,
                    'calculatorType': this.options.calculatorType,
                    'price': this.options.sum,
                    'credit_sum': this.options.creditSum,
                    'initial_fee': this.options.initFee,
                    'credit_term': {
                        value: this.options.term,
                        unit: 'year',
                    },
                    'credit_rate': this.options.rate,
                    'credit_type': this.options.creditType,
                    'credit_early_payments': JSON.stringify(this.options.earlyPayments),
                })
                .then((response) => {

                    document.dispatchEvent(new CustomEvent(ReportQuery.CHANGED_EVENT, { detail: {
                        details: response.report.details,
                        tab: this.options.tab,
                    } }));

                    resolve(response);
                });
        });

        return this.lastFetch;
    }
}